<h1 class="page-heading">MIS Portal</h1>
<div class="login-page">
  <div class="login-container">
    <div class="image-section">
      <img src="/assets/beatzlogo.png" alt="Company Logo" />
    </div>
    <div class="form-section">
      <h2>Login Credentials</h2>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="email">Email <span class="text-danger">*</span></label>
          <div class="input-group">
            <input type="email" id="email" formControlName="email" placeholder="Email"
              [ngClass]="{ 'error-border': loginForm.get('email')?.invalid && loginForm.get('email')?.touched }" />
            <span class="icon"><i class="fa fa-user"></i></span>
          </div>
          <div class="error-message" *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
            <span *ngIf="loginForm.get('email')?.errors?.['required']">Email is required.</span>
            <span *ngIf="loginForm.get('email')?.errors?.['pattern']">Please enter a valid email address.</span>
          </div>
        </div>

        <div class="form-group">
          <label for="password">Password <span class="text-danger">*</span></label>
          <div class="input-group">
            <input type="password" id="password" formControlName="password" placeholder="Password"
              [ngClass]="{ 'error-border': loginForm.get('password')?.invalid && loginForm.get('password')?.touched }"
              (keydown)="preventSpace($event)" />
            <span class="icon"><i class="fa fa-lock"></i></span>
          </div>
          <div class="error-message" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
            <span *ngIf="loginForm.get('password')?.errors?.['required']">Password is required.</span>
          </div>
        </div>

        <div class="remember-me" style="margin-bottom: 15px;">
          <input type="checkbox" id="remember-me" formControlName="rememberMe" />
          <label for="remember-me" style="margin-left: 5px;">Remember Me</label>
        </div>

        <div class="recaptcha mb-3">
          <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (reset)="handleReset()" (expire)="handleExpire()"
            (load)="handleLoad()" (success)="handleSuccess($event)" [useGlobalDomain]="false"
            formControlName="recaptcha"></ngx-recaptcha2>
        </div>

        <button class="button" type="submit">Submit</button>
      </form>

      <div class="error-message" *ngIf="errorMessage">{{ errorMessage }}</div>
      <a (click)="forgot()" class="forgot-password">Forgot Password?</a>
    </div>
  </div>

  <div id="customToast" class="toast">
    <i class="fa fa-check" style="margin-right: 5px;"></i>
    <p style="display: inline;">Login Successfully</p>
  </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>
